/* Manual photo cycler for collection-grid product cards.
 *
 * Replaces the old "instant swap to 2nd photo on hover" - our gallery
 * shots differ a lot (closeups, scenes, flat-lays), so a surprise swap
 * reads as a different product. Instead: arrows + dots that reveal on
 * hover (always-visible dots on touch) let the shopper page through up
 * to 5 photos deliberately.
 *
 * Markup comes from card-product.liquid:
 *   <card-media-cycler>
 *     <img class="card-cycler__img is-active"> ... more slides ...
 *     <button data-cycler-action="prev|next">
 *     <div class="card-cycler__dots"><button data-cycler-action="dot" data-cycler-index="N">
 *   </card-media-cycler>
 *
 * Clicks are swallowed (preventDefault + stopPropagation) so the card's
 * stretched product link underneath doesn't navigate.
 */
/* Window-property guard, same pattern as card-variant-picker.js - Shopify
 * may re-evaluate assets on section re-renders; a bare `class X` redeclare
 * would throw. */
window.CardMediaCycler = window.CardMediaCycler || class extends HTMLElement {
  connectedCallback() {
    this.slides = Array.from(this.querySelectorAll('.card-cycler__img'));
    if (this.slides.length < 2) return;
    // Controls live OUTSIDE this element (siblings under .card__inner) so
 // their z-index can rise above the card link's stretched ::after - 
    // see card-product.liquid. Query and listen from the shared parent.
    const root = this.closest('.card__inner') || this;
    this.dots = Array.from(root.querySelectorAll('.card-cycler__dot'));
    this.index = 0;
    root.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-cycler-action]');
      if (btn) {
        e.preventDefault();
        e.stopPropagation();
        const action = btn.dataset.cyclerAction;
        if (action === 'prev') this._go(this.index - 1);
        else if (action === 'next') this._go(this.index + 1);
        else this._go(parseInt(btn.dataset.cyclerIndex, 10));
        return;
      }
      // The raised .card__inner (see component-card.css) sits above the
      // card's stretched link overlay, so photo clicks land on inert inner
 // elements instead - navigate explicitly. Real links (e.g. the inner
      // a11y heading link) keep their native behaviour.
      if (e.target.closest('a[href]')) return;
      const link = this.closest('.card-wrapper')?.querySelector('.card__heading a[href]');
      if (link) window.location.href = link.href;
    });
    this.style.cursor = 'pointer';
  }

  _go(i) {
    const n = this.slides.length;
    this.index = ((i % n) + n) % n;
    this.slides.forEach((s, j) => s.classList.toggle('is-active', j === this.index));
    this.dots.forEach((d, j) => d.classList.toggle('is-active', j === this.index));
  }
};

if (!customElements.get('card-media-cycler')) {
  customElements.define('card-media-cycler', window.CardMediaCycler);
}
